import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Bullets, Note } from "@/components/Bits";

const BULLETS = [
  "Dollars, never points",
  "Funded by the participating business, not MONOE",
  "Applied at checkout toward a future eligible purchase",
  "Kept separately at each business (no combined MONOE balance, no wallet)",
  "Not cash (can't be withdrawn or transferred)",
];

const Rewards = () => {
  useSeo({
    title: "Rewards",
    description: "MONOE Rewards are real dollars, not points — merchant-funded and applied toward future eligible purchases.",
    path: "/rewards",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Rewards"
        title="MONOE Rewards — real dollars, not points."
        intro="Businesses that choose to participate offer dollar-denominated rewards you can use toward future eligible purchases. Businesses set up and fund their own programs — percent back, spend-and-earn, visit frequency, or a custom promotion — and can offer an optional birthday reward."
        testId="rewards-hero"
      />
      <section>
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <Reveal>
            <Bullets items={BULLETS} testId="rewards-bullets" />
          </Reveal>
          <Reveal delay={0.05}>
            <Note testId="rewards-note">
              Businesses choose whether to participate — rewards are off unless a business turns them
              on.
            </Note>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Rewards;
